import en from "./en.json";
import es from "./es.json";

const resourcesMap = {
  en,
  es,
};

export default resourcesMap;
